package com.arenaproplay.admin.ui.components.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.arenaproplay.admin.ui.utils.sBorderRadius
import com.arenaproplay.admin.ui.utils.sPadding

/**
 * Night Arena glass card — rgba(255,255,255,.04) surface with a .08 hairline
 * border and backdrop blur (`.na-glass` in AppTheme CSS). The building block
 * of every dark surface.
 *
 * @param hoverElevate adds the dark hover elevation/border highlight.
 */
@Composable
fun GlassCard(
    modifier: Modifier = Modifier,
    radius: Int = 16,
    padding: Int = 18,
    hoverElevate: Boolean = false,
    content: @Composable ColumnScope.() -> Unit
) {
    Box(
        modifier
            .fillMaxWidth()
            .sBorderRadius(radius)
            .classNames("na-glass")
            .then(if (hoverElevate) Modifier.classNames("na-glass-hover") else Modifier)
    ) {
        Column(Modifier.fillMaxWidth().sPadding(padding)) {
            content()
        }
    }
}

/**
 * Hero glass surface — larger radius (24) and more generous padding, for
 * hero blocks and modals per the Night Arena spec.
 */
@Composable
fun HeroGlass(
    modifier: Modifier = Modifier,
    padding: Int = 24,
    content: @Composable ColumnScope.() -> Unit
) {
    GlassCard(modifier, radius = 24, padding = padding, content = content)
}
